export function shouldAutomaticallyPreparePrivateShareLink({
  requiresPrivateLink,
  privateUrl,
  isPending,
  attemptKey,
  lastAttemptKey,
}: {
  requiresPrivateLink: boolean;
  privateUrl: string | null;
  isPending: boolean;
  attemptKey: string;
  lastAttemptKey: string | null;
}) {
  return (
    requiresPrivateLink &&
    !privateUrl &&
    !isPending &&
    attemptKey !== lastAttemptKey
  );
}
